<script lang="ts">
	import { onMount } from 'svelte';
	import { push } from 'svelte-spa-router';
	import Navbar from '../../components/Navbar.svelte';
	import AdminSidebar from '../../components/dashboard/AdminSidebar.svelte';
	import RepositorySearch from '../../components/dashboard/RepositorySearch.svelte';
	import { appStore } from '../../stores/appStore';
	import { get } from 'svelte/store';

	let isAdmin = false;
	let loading = true;

	onMount(async () => {
		const profile = get(appStore).profile;
		if (!profile || profile.userRole !== 'admin') {
			push('/');
			return;
		}
		isAdmin = true;
		loading = false;
	});
</script>

<Navbar />

<div class="page-wrapper">
	{#if loading}
		<div class="loading">Loading...</div>
	{:else if isAdmin}
		<div class="page-layout">
			<AdminSidebar />
			<div class="page-main">
				<div class="page-header">
					<h1>Global Search</h1>
					<p>Search across all repositories including private ones</p>
				</div>
				<RepositorySearch />
			</div>
		</div>
	{/if}
</div>

<style>
	.page-wrapper {
		min-height: 100vh;
		background: var(--bg-primary, #0d1117);
	}

	.loading {
		display: flex;
		justify-content: center;
		align-items: center;
		min-height: 80vh;
	}

	.page-layout {
		display: flex;
		min-height: calc(100vh - 60px);
	}

	.page-main {
		flex: 1;
		padding: 2rem;
		overflow-y: auto;
	}

	.page-header {
		margin-bottom: 2rem;
	}

	.page-header h1 {
		font-size: 2rem;
		font-weight: 600;
		margin: 0 0 0.5rem 0;
		color: var(--text-primary, #e6edf3);
	}

	.page-header p {
		color: var(--text-secondary, #8b949e);
		margin: 0;
	}
</style>
